import './App.css';
import { ThemeProvider } from '@emotion/react';
import { CssBaseline } from '@mui/material';
import { BrowserRouter, HashRouter, Route, Routes, useLocation } from 'react-router-dom';
import theme from './theme';
import { RouteWrapper } from './pages/ConsolePages/RouteWrapper';

const BuildTarget = process.env.REACT_APP_TARGET;
const ApiPath = process.env.REACT_APP_API_PATH;
const Origin = window.location.origin; 

function App() {
  return (
    <>
    {(() => {
      console.log(BuildTarget);
      console.log(ApiPath);
      console.log(Origin);

      if (BuildTarget === "WEB") {
        return (
          <BrowserRouter basename="/">
            <PageRoute />
          </BrowserRouter>
        );
      }

      // アプリ用にHashRouterを使う
      // ！注意！
      // HashRouterを使っているためリンクの形は`http://{domain}/#/console/`のようになる。
      if (BuildTarget === "APP") {
        return (
          <HashRouter basename="/">
            <PageRoute />
          </HashRouter>
        );
      }

      return <>未作成</>;
    })()}
    </>
  );
}

function PageRoute() {
  // オリジナルのパスを記憶する
  const location = useLocation();
  const originalPath = (location.state as { from?: Location })?.from?.pathname;

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        <Route key="systemAdmin" path={"/system-admin/*"} element={<RouteWrapper originalPath={originalPath} />} />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
